import React from "react";
import { FormProvider } from "react-hook-form";
import { useNavigate } from "react-router";
import { Divider, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Edit } from "@refinedev/mui";

import { HistoryTimeline, ReferralForm } from "@modules/partners/components";
import { useReferralEditForm } from "./controller";

const REFERRALS_LIST_PATH = "/partners?tab=referrals";

export const ReferralEdit = React.memo(() => {
  const navigate = useNavigate();
  const {
    methods,
    handleSubmit,
    mutateAsync,
    isPending,
    formLoading,
    id,
    history,
    translate,
  } = useReferralEditForm();

  return (
    <Edit
      resource="v1/partner_referral_admin"
      recordItemId={id}
      goBack={
        <IconButton onClick={() => navigate(REFERRALS_LIST_PATH)}>
          <ArrowBackIcon />
        </IconButton>
      }
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
      isLoading={formLoading}
    >
      <FormProvider {...methods}>
        <ReferralForm />
      </FormProvider>

      <Divider sx={{ my: 3 }} />
      <Typography variant="h6" sx={{ mb: 1 }}>
        {translate("partners.detail.history")}
      </Typography>
      <HistoryTimeline entries={history} />
    </Edit>
  );
});
